var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    fill: "currentColor",
    width: 1,
    height: 1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 1.5A7.5 7.5 0 001.5 9 7.5 7.5 0 009 16.5 7.5 7.5 0 0016.5 9 7.5 7.5 0 009 1.5zM7.354 13.579c3.454-.156 5.768-2.634 5.815-6.252.377-.314.815-.687 1.016-1.103-.323.16-.7.263-1.128.321.39-.284.708-.64.874-1.15-.402.213-.822.408-1.335.507C11.38 4.43 8.474 5.618 8.987 7.81 6.944 7.685 5.7 6.76 4.667 5.626c-.591.958-.076 2.407.621 2.804-.362-.022-.634-.134-.895-.253.034 1.206.699 1.781 1.63 2.093-.294.063-.598.07-.896.022.286.845.897 1.37 1.93 1.471-.699.597-2.004 1.018-3.057.85.898.57 1.93 1.03 3.354.966z",
    clipRule: "evenodd",
    fillOpacity: 0.75,
    fill: "#EFF1F6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.46fa5a66b3a95e429616804449db0acc.svg";
export { ForwardRef as ReactComponent };